import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { ImageType } from '../types';
import { toFriendlyName } from '../utilities';
import styles from './EmptyPicture.module.scss';

/** Placeholder component when there is no picture uploaded */

export const EmptyPicture: React.FC<
  React.PropsWithChildren<{ children?: never; type: ImageType; required: boolean }>
> = ({ type, required }) => {
  return (
    <div className={styles['empty-picture']}>
      <div className={styles['empty-picture-icon-container']}>
        <FontAwesomeIcon icon={faPlus} size="sm" />
      </div>
      <div>{toFriendlyName(type)}</div>
      <div className={styles['required-label']}>{required ? 'Required' : null}</div>
    </div>
  );
};
